export default __webpack_public_path__ + "db9c3c2414c32777ad4db4cfe064ad59.jpg";